// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__1l0Uz","Header":"App_Header__2VHHa","MapContainer":"App_MapContainer__1OdSG","MapWraps":"App_MapWraps__2pU_2","Loader":"App_Loader__3Z-py"};